import React from "react";
import { toAttachmentUrl } from "../constants/avatar";
import VerifiedBadge from "./VerifiedBadge";
import { isVerifiedUser } from "../constants/verifiedUsers";

const formatRelativeTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  const diffMs = Date.now() - date.getTime();
  const diffSec = Math.max(1, Math.floor(diffMs / 1000));
  if (diffSec < 60) return `${diffSec}s ago`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHour = Math.floor(diffMin / 60);
  if (diffHour < 24) return `${diffHour}h ago`;
  const diffDay = Math.floor(diffHour / 24);
  return `${diffDay}d ago`;
};

const canAct = (item) =>
  item.type === "FOLLOW_REQUEST" || item.type === "JOIN_ROOM_REQUEST" || item.type === "ROOM_INVITE";

export default function NotificationsPanel({
  notifications = [],
  loading = false,
  onAccept = () => {},
  onDecline = () => {},
  onStartChat = () => {}
}) {
  return (
    <section className="notifications-panel glass inline" aria-label="Notifications">
      <header className="notifications-head">
        <h3>Notifications</h3>
      </header>
      <div className="notifications-list compact">
        {loading ? <p className="muted">Loading notifications...</p> : null}
        {!loading && notifications.length === 0 ? <p className="muted">No notifications yet.</p> : null}
        {!loading
          ? notifications.map((item) => {
              const senderName = item.sender?.displayName || item.sender?.username || "User";
              const avatarUrl = toAttachmentUrl(item.sender?.avatarUrl || "");
              const canStartChat = (item.type === "NEW_FOLLOWER" || item.type === "FOLLOW_ACCEPTED") && (item.sender?.id || item.senderId);
              const targetUserId = item.sender?.id || item.senderId || "";
              return (
                <article
                  key={item.id}
                  className={`notification-card ${item.isRead ? "read" : "unread"}`}
                >
                  <span className="notification-avatar">
                    {avatarUrl ? (
                      <img src={avatarUrl} alt={senderName} />
                    ) : (
                      <span>{senderName.slice(0, 2).toUpperCase()}</span>
                    )}
                  </span>
                  <div className="notification-copy">
                    <strong className="name-with-badge">
                      {senderName}
                      {isVerifiedUser(item.sender || item.senderId) ? <VerifiedBadge /> : null}
                    </strong>
                    <p>{item.message}</p>
                    <small>{formatRelativeTime(item.createdAt)}</small>
                    {canAct(item) && !item.actionState ? (
                      <div className="notification-actions compact">
                        <button type="button" className="primary-btn" onClick={() => onAccept(item.id)}>
                          Accept
                        </button>
                        <button type="button" className="ghost-btn" onClick={() => onDecline(item.id)}>
                          Decline
                        </button>
                      </div>
                    ) : null}
                    {item.type === "ROOM_INVITE" && item.actionState === "accepted" ? (
                      <div className="notification-actions compact">
                        <button type="button" className="primary-btn" disabled>
                          Joined successfully
                        </button>
                      </div>
                    ) : null}
                    {canStartChat ? (
                      <div className="notification-actions compact">
                        <button type="button" className="primary-btn" onClick={() => onStartChat(targetUserId)}>
                          Start chatting
                        </button>
                      </div>
                    ) : null}
                  </div>
                </article>
              );
            })
          : null}
      </div>
    </section>
  );
}
